import {
    GET_GRAPH_VALIDATE_CODE,
    GET_SMS_CODE,
    GET_SEND_SMS_COUNT
} from '../mutationTypes'
import {
    getGraphValidateCode
} from '@/models/getGraphValidateCode'
import {
    getSmsCode,
    getSendSmsCount
} from '@/models/getSmsCode'
const state = {
    beasImg: '',
    smsCode: '',
    beasImgId: '',
    smsSendCount: 0
}

const mutations = {
    [GET_GRAPH_VALIDATE_CODE] (state, res) {
        state.beasImg = res.img
        state.beasImgId = res.id
    },
    [GET_SMS_CODE] (state, res) {
    },
    [GET_SEND_SMS_COUNT] (state, res) {
        state.smsSendCount = res.send_time
    }
}

export const actions = {
    async getGraphValidateCode ({ commit }, params) {
        return new Promise((resolve, reject) => {
            try {
                getGraphValidateCode(params)
                    .then(data => {
                        commit(GET_GRAPH_VALIDATE_CODE, data)
                        resolve(data)
                    })
                    .catch(err => {
                        resolve(err)
                    })
            } catch (err) {
                resolve(err)
            }
        })
    },
    async getSmsCode ({ commit }, params) {
        params = Object.assign({}, params, {
            id: state.beasImgId
        })
        const data = await getSmsCode(params)
        commit(GET_SMS_CODE, data)
    },
    async getSendSmsCount ({ commit }, params) {
        const data = await getSendSmsCount(params)
        commit(GET_SEND_SMS_COUNT, data)
    }
}

export const getters = {}

export default {
    state,
    mutations
}
